import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, setDisplayName, setPropTypes } from 'recompose';
import PackageInformation from '../PackageInformation';
import getServiceProperty from '../../../../helpers/getServiceProperty';
import { getServicePrice } from '../../../../selectors';
import styles from './PaymentWizardPage.scss';

export const PaymentWizardPage = ({
  step, options, steps, subscription: { data, meta },
}) => (
  <div className={styles.root}>
    <PackageInformation
      title={data.title}
      period={data.periodUnit}
      type={meta.type}
      price={data.price}
      offer={meta.offer}
      periodInNumber={data.period}
      originalPrice={data.originalPrice}
      voucherCode={data.voucherCode}
    />
    {
      steps.map((paymentStep, index) => {
        const Wizard = paymentStep.component;

        return (
          <div className={styles.section} key={paymentStep.id}>
            {
              step === index &&
                <Wizard {...options} packageTitle={data.title} voucherCode={data.voucherCode} />
            }
          </div>
        );
      })
    }
  </div>
);

const mapStateToProps = (state) => {
  const subscriptionData = state.subscriptions.selected;
  const type = getServiceProperty(subscriptionData.id, 'type').toLowerCase();
  const offer = getServiceProperty(subscriptionData.id, 'offer');
  const price = getServicePrice(state);

  return {
    subscription: {
      data: subscriptionData,
      meta: {
        type,
        price,
        offer,
      },
    },
  };
};

export default compose(
  setDisplayName('PaymentWizardPage'),
  connect(mapStateToProps),
  setPropTypes({
    step: PropTypes.number.isRequired,
  }),
)(PaymentWizardPage);
